export default __webpack_public_path__ + "static/step7-db941bb9373069d12438e1423bb641af.svg";